import { DineroBeraEthAbi } from '../abis/dinero'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Dinero beraETH reader.
 *
 * beraETH is a wrapper over the rberaETH base LST and is not ERC-4626
 * (`asset()`/`convertToAssets()` revert). Two calls:
 * `beraETH.totalSupply()` + `beraETH.LSTPerToken()` (the 1e18-scaled
 * underlying-per-share rate, ≈1.0535 at time of writing). The ETH rate is
 * synced cross-chain from Dinero's mainnet apxETH engine, so reading it on
 * the token is sufficient — no extra contract needed.
 */
export const readerDineroBeraEth = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalSupply', params: [] },
    { address: entry.address, name: 'LSTPerToken', params: [] },
  ],
  abis: [TotalSupplyAbi, DineroBeraEthAbi],
  parse: ([supply, rate]) => {
    const totalSupply = toBigInt(supply)
    const exchangeRate = toBigInt(rate)
    if (totalSupply === undefined || exchangeRate === undefined) {
      return undefined
    }
    return {
      totalAssets: (totalSupply * exchangeRate) / ONE_E18,
      totalSupply,
      exchangeRate,
    }
  },
})
